module.exports = __webpack_public_path__ + "static/overview-shop-3@2x-1291398b51a59f2e81ac68d3685d9fd7.jpg";